export default class PDFViewController {
  constructor() {}
  getCurrentViewMode() {
    return pdfui.pdfViewer.viewModeManager.getCurrentViewMode().getName()
  }
}